function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  y: 0.206894,
  width: 37,
  height: 37,
  rx: 8,
  fill: "#2C293E"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M18.4998 17.6513C16.1679 17.6513 14.2776 15.761 14.2776 13.4291C14.2776 11.0972 16.1679 9.20689 18.4998 9.20689C20.8317 9.20689 22.722 11.0972 22.722 13.4291C22.722 15.761 20.8317 17.6513 18.4998 17.6513Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.00069 27.3616C9.40983 22.3238 13.4987 19.7625 18.4824 19.7625C23.5363 19.7625 27.6885 22.183 27.9978 27.3624C28.0101 27.5688 27.9978 28.2069 27.2048 28.2069C23.2934 28.2069 17.4811 28.2069 9.76792 28.2069C9.5032 28.2069 8.9784 27.636 9.00069 27.3616Z",
  fill: "white"
});

function SvgDashUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashUser);
export default __webpack_public_path__ + "static/media/dash-user.ebe18e3c.svg";
export { ForwardRef as ReactComponent };